import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppPermission, PermissionService } from '../services/permission.service';

/**
 * Blocca l'accesso alla route se manca il permesso indicato in `data.permission`.
 * Redirect di default: `/documenti-adempimenti/gestione` (override con `data.permissionRedirect`).
 */
export const permissionGuard: CanActivateFn = (route) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const permission = route.data['permission'] as AppPermission | undefined;
  if (!permission) {
    return true;
  }

  if (permissionService.can(permission)) {
    return true;
  }

  const redirect = (route.data['permissionRedirect'] as string | undefined)
    ?? '/documenti-adempimenti/gestione';
  return router.parseUrl(redirect);
};
